import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import "../styles/tennis-betting.css";

const TennisBettingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;

  return (
    <div className="tennis-betting-page">
      <Helmet>
        <title>Reddy Anna - Tennis Betting India for ATP & WTA Matches</title>
        <meta
          name="description"
          content="Join Reddy Anna tennis betting in India. Bet on ATP and WTA matches with secure ID and live odds."
        />
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "Service",
 "name": "Reddy Anna - Tennis Betting India for ATP & WTA Matches",
 "url": "https://reddyannaaid.com/tennis-betting",
 "description": "Join Reddy Anna tennis betting in India. Bet on ATP and WTA matches with secure ID and live odds.",
 "provider": {
   "@type": "Organization",
   "name": "Reddy Anna"
 },
 "areaServed": "India"
}

          `}
        </script>
      </Helmet>
      <section className="tennis-betting-intro">
        <div className="tennis-betting-intro-content">
          <h1>
            <span>Reddy Anna Tennis Betting:</span> Where Strategy Meets
            Excitement
          </h1>
          <p>
            Welcome to Reddy Anna Tennis Betting – your ultimate platform for
            thrilling tennis betting action! Whether you’re cheering for Grand
            Slam champions or uncovering the next tennis star, our platform
            offers a dynamic blend of excitement and precision. Experience
            tennis like never before with Reddy Anna!
          </p>
          <div className="tennis-betting-cta-buttons">
            <a
              href={whatsappLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Your Demo Account
            </a>
            <a
              href={ContactLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="tennis-betting-intro-image">
          <img
            src="/tennis-betting.webp"
            alt="Tennis Betting Excitement"
            className="tennis-image"
          />
        </div>
      </section>

      <section className="tennis-betting-features">
        <h2>
          Why Choose <span>Reddy Anna Tennis Betting?</span>
        </h2>
        <ul>
          <li>
            <strong>Comprehensive Betting Markets:</strong> Explore a variety of
            betting options, from Grand Slams to ATP and WTA matches. Bet on
            singles, doubles, and mixed doubles for a complete tennis
            experience.
          </li>
          <li>
            <strong>Real-Time Live Betting:</strong> Experience the thrill of
            live tennis betting as matches unfold. Make real-time decisions and
            immerse yourself in every serve, rally, and match point.
          </li>
          <li>
            <strong>User-Centric Interface:</strong> Enjoy seamless navigation
            with a platform designed for all users. Access upcoming matches,
            odds, and features effortlessly, regardless of your experience
            level.
          </li>
          <li>
            <strong>Detailed Insights:</strong> Stay informed with match
            previews, player stats, and expert analyses. Our insights help you
            make well-informed betting decisions for every match.
          </li>
          <li>
            <strong>Secure Transactions:</strong> Bet with confidence on a
            platform that prioritizes your privacy and security through advanced
            encryption technologies.
          </li>
          <li>
            <strong>Responsible Gaming Commitment:</strong> Manage your betting
            responsibly with tools like deposit limits and self-exclusion
            options. Enjoy a safe and balanced experience with Reddy Anna.
          </li>
        </ul>
        <div className="tennis-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="tennis-betting-getting-started">
        <h2>
          <span>Exceptional Customer Support</span> at Your Service
        </h2>
        <p>
          At Reddy Anna Tennis, your satisfaction is our priority. Our dedicated
          support team is available to assist you with any questions or
          concerns, ensuring a smooth betting experience. From account setup to
          advanced betting strategies, we’re here for you.
        </p>
        <p>
          Join Reddy Anna Tennis today and explore the ultimate tennis betting
          experience. From major tournaments to emerging talent, every match is
          an opportunity to elevate your excitement and strategy. Your tennis
          betting journey starts here!
        </p>
      </section>

      <section className="tennis-betting-join">
        <h2>
          Join <span>Reddy Anna Tennis</span> Now!
        </h2>
        <p>
          Enhance your love for tennis with Reddy Anna Tennis Betting. With
          competitive odds, expert insights, and a user-friendly platform, we
          are your trusted partner for tennis betting excitement. Bet
          responsibly and elevate every match to a new level of thrill!
        </p>
        <div className="tennis-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default TennisBettingPage;
